import React from "react";
import { Provider } from "react-redux";
import store from './store';
import App from "./routes/App.jsx";

function PaymentPartnersIndex (props) {
    return (
        <Provider store={store}>
            <App recruiters={props.recruiters}
                clients={props.clients}/>
        </Provider>
    )
}

export default PaymentPartnersIndex;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/PaymentPartnersIndex.jsx